import { CustomError, mapToAlertErrors } from 'core/errors';
import { CustomTextField, SubmitButton } from 'components/forms';
import { Field, Form, useFormikContext } from 'formik';
// eslint-disable-next-line
import React, { useEffect } from 'react';
import { Theme, makeStyles } from '@material-ui/core/styles';

import Alert from 'components/Alert';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import { Nullable } from 'utils/types';
import { RGX_ALPHANUMERIC } from 'utils/helpers';
import { selectAuthLoading } from 'store/modules/auth';
import { useSelector } from 'react-redux';
import SlideAnimation from 'components/SlideAnimation';
import dictionary from 'utils/dictionary';

export type LoginFormValues = {
  name: string;
  password: string;
};

const useStyles = makeStyles((theme: Theme) => ({
  form: {
    alignItems: 'center',
    height: '15rem',
    marginTop: theme.spacing(3),
  },
}));

type Props = {
  serverError: Nullable<CustomError>;
  onFormValueChanged?: () => void;
};

const LoginForm: React.FC<Props> = ({ serverError, onFormValueChanged }) => {
  const classes = useStyles();
  const { setSubmitting } = useFormikContext<LoginFormValues>();
  const isFetching = useSelector(selectAuthLoading);

  useEffect(() => {
    setSubmitting(isFetching);
  }, [isFetching, setSubmitting]);

  return (
    <Form>
      <Grid container className={classes.form}>
        <Field
          id="name"
          name="name"
          label={dictionary.loginForm_name}
          fullWidth
          regex={RGX_ALPHANUMERIC}
          component={CustomTextField}
          onKeyDown={onFormValueChanged}
        />

        <Field
          id="password"
          name="password"
          label={dictionary.loginForm_pass_label}
          type="password"
          fullWidth
          component={CustomTextField}
          onKeyUp={onFormValueChanged}
        />

        {serverError && (
          <Box width="100%" mt={4}>
            <SlideAnimation direction="down" data-testid="login-alert">
              <Alert {...mapToAlertErrors(serverError)} />
            </SlideAnimation>
          </Box>
        )}

        <Box width={100}>
          <SubmitButton loading={isFetching} style={{ width: '100%' }}>
            {dictionary.loginForm_continueBotton}
          </SubmitButton>
        </Box>
      </Grid>
    </Form>
  );
};

export default LoginForm;
